import { render, staticRenderFns } from "./usergroup.vue?vue&type=template&id=2cc65720&scoped=true&"
import script from "./usergroup.vue?vue&type=script&lang=js&"
export * from "./usergroup.vue?vue&type=script&lang=js&"
import style0 from "./usergroup.vue?vue&type=style&index=0&id=2cc65720&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc65720",
  null
  
)

export default component.exports